const FBP_COOKIE = "_fbp";
const FBC_COOKIE = "_fbc";
const COOKIE_MAX_AGE_DAYS = 90;

function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const prefix = `${name}=`;
  for (const part of document.cookie.split(";")) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length)) || null;
    }
  }
  return null;
}

function writeCookie(name: string, value: string, maxAgeDays = COOKIE_MAX_AGE_DAYS) {
  /* istanbul ignore next -- every caller returns earlier when `document` is missing */
  if (typeof document === "undefined") return;
  const maxAge = maxAgeDays * 24 * 60 * 60;
  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:"
      ? "; Secure"
      : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
}

/** Meta browser id cookie; create a first-party value if Pixel has not set one yet. */
export function getOrCreateFbp(): string | null {
  if (typeof document === "undefined") return null;
  const existing = readCookie(FBP_COOKIE);
  if (existing) return existing;
  const value = `fb.1.${Date.now()}.${Math.floor(Math.random() * 1e10)}`;
  writeCookie(FBP_COOKIE, value);
  return value;
}

export function getFbp(): string | null {
  return readCookie(FBP_COOKIE);
}

export function getFbc(): string | null {
  return readCookie(FBC_COOKIE);
}

/**
 * Persist Meta click id from `fbclid` query param as `_fbc`.
 * Format: fb.1.{creationTime}.{fbclid}
 */
export function captureFbclidFromLocation(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const fbclid = new URLSearchParams(window.location.search).get("fbclid")?.trim();
    if (!fbclid) return getFbc();
    const value = `fb.1.${Date.now()}.${fbclid}`;
    writeCookie(FBC_COOKIE, value);
    return value;
  } catch (err) {
    console.error("Failed to capture fbclid", err);
    return getFbc();
  }
}
